/* eslint-disable max-len */
import { RoundedSection } from 'Containers/app/common/RoundedSection/RoundedSection';
import { Content } from 'LegacySBCRA/Content/Content';

import imageAvif from '../../../../../../../client/assets_seller/landingpages/driving_gloves/driving-gloves.avif';
import imageJpeg from '../../../../../../../client/assets_seller/landingpages/driving_gloves/driving-gloves.jpg';
import imageWebp from '../../../../../../../client/assets_seller/landingpages/driving_gloves/driving-gloves.webp';

import styles from './ThePrize.scss';

export const ThePrize = () => <RoundedSection withBottomLedge withTopLedge theme="primary-yellow">
  <Content>
    <>
      <header className={styles.header}>
        <h2 className={styles.title}>The prize</h2>
        <p data-thc-style-override>By entering the prize draw, you are in with a chance of winning a pair of limited-edition D(r)iving Gloves, signed by David Seaman himself.</p>
      </header>
      <figure className={styles.figure}>
        <div className={styles.imageWrapper}>
          <picture>
            <source srcSet={imageAvif} type="image/avif" />
            <source srcSet={imageWebp} type="image/webp" />
            <img alt="A pair of hands sporting the signed David Seaman Driving Gloves, resting upon the wheel of a vintage car" height="395" src={imageJpeg} width="504" />
          </picture>
          <svg className={styles.overlay} fill="none" viewBox="0 0 504 395" xmlns="http://www.w3.org/2000/svg">
            <g className={styles.group1} fill="#fff">
              <rect height="28" rx="14" width="28" x="436" y="220"/>
              <path d="M449.806 238.8v-7.042H448v-1.316h.476c1.134 0 1.47-.518 1.596-1.442h1.386v9.8z" fill="#242424"/>
              <path d="M438 233.5v1h-46v-1z"/>
            </g>
            <g className={styles.group2} fill="#fff">
              <rect height="28" rx="14" width="28" x="176" y="222"/>
              <path d="M193.603 240.667h-7.028v-1.344c1.624-1.12 2.744-1.974 3.57-2.716 1.176-1.092 1.554-1.876 1.554-2.688 0-.994-.686-1.764-1.82-1.764-1.316 0-2.058 1.022-1.904 2.324l-1.568-.07c-.182-2.1 1.204-3.682 3.556-3.682 2.128 0 3.444 1.414 3.444 3.108 0 1.022-.378 1.974-1.414 3.066-.644.686-1.568 1.4-2.912 2.31v.028h4.522z" fill="#242424"/>
              <path d="M254.5 236v1h-54v-1z"/>
            </g>
            <g className={styles.group3} fill="#fff">
              <rect height="28" rx="14" width="28" x="280" y="32"/>
              <path d="m291.778 43.562-1.512-.434c.49-1.204 1.834-2.128 3.598-2.128 2.002 0 3.304 1.134 3.304 2.688 0 .84-.546 1.75-1.414 2.114v.028a2.3 2.3 0 0 1 1.638 2.198c0 1.778-1.498 3.052-3.64 3.052-1.862 0-3.276-.896-3.752-2.296l1.568-.504c.294.77 1.092 1.372 2.17 1.372 1.162 0 1.946-.658 1.946-1.582s-.742-1.512-1.862-1.512h-.728v-1.33h.658c1.092 0 1.708-.56 1.708-1.414 0-.812-.672-1.386-1.68-1.386-.98 0-1.694.532-2.002 1.134" fill="#242424"/>
              <path d="M294 57.5V86h22v1h-23V57.5z"/>
            </g>
            <g className={styles.group4} fill="#fff">
              <rect height="28" rx="14" width="28" x="362" y="301"/>
              <path d="M371.955 317.231v-1.554l4.424-5.81h2.072v5.936h1.512v1.428h-1.512v2.436h-1.624v-2.436zm4.872-1.428v-4.284h-.028l-3.29 4.256v.028z" fill="#242424"/>
              <path d="M376 267.5V305h-1v-36.5h-25v-1z"/>
            </g>
          </svg>
        </div>
        <figcaption>
          <ol className={styles.list}>
            <li className={styles.link1}>Grip-enhancing pleather upper built for ball and wheel control.</li>
            <li className={styles.link2}>A wrist strap made from seatbelt fabric (yes, really).</li>
            <li className={styles.link3}>40 breathable air holes for Seaman's 40 international clean sheets.</li>
            <li className={styles.link4}>Signed by the legend, David Seaman.</li>
          </ol>
        </figcaption>
      </figure>
    </>
  </Content>
</RoundedSection>;
